import { Header } from '@components/Organisms/Header';
import type { FC } from 'react';
import { REVERSE_GROUP_BRAND_LOGOS } from '@app/constants/brand';

export const PageLoginHeader: FC = () => {
  const logo = __ENVIRONMENT_CONFIG__.IS_THEME_AKI
    ? REVERSE_GROUP_BRAND_LOGOS.AKI
    : REVERSE_GROUP_BRAND_LOGOS.IT;

  return (
    <Header
      className="c-page-login__header"
      logo={`${__ENVIRONMENT_CONFIG__.PUBLIC_URL}${logo}`}
    />
  );
};
